import { observer } from 'mobx-react';
import React from 'react';

export interface TranslationsLinks {
    html: string;
    path: string;
    title: string;
}
export type TTranslations = { [key: string]: string };
type TranslationContextProps = { allTranslations: TTranslations; children?: React.ReactChild };

const defaultContext = {};

export const TranslationContextProvider = React.createContext<TTranslations>({});

export const TranslationContext: React.FC<TranslationContextProps> = observer((props) => {
    const { allTranslations, children } = props;

    return (
        <TranslationContextProvider.Provider value={allTranslations || defaultContext}>
            {children}
        </TranslationContextProvider.Provider>
    );
});
